/**
 * Pure math behind InfoTip's viewport-edge clamping (see InfoTip.tsx). A
 * symmetric CSS-only clamp can't work here — the trigger's distance to the
 * viewport edge isn't knowable in pure CSS — so the component measures the
 * trigger's viewport position on hover/focus and computes a pixel shift.
 *
 * The tip is normally centered on the trigger: `left: 50%` (of the trigger,
 * its positioned ancestor) + `transform: translateX(-tipWidth/2)` puts the
 * tip's horizontal center on the trigger's center. This returns the actual
 * (possibly de-centered) shift to use instead, so the tip's edges stay
 * within `[margin, viewportWidth - margin]`.
 */
export function computeTipShift(
  wrapperCenterX: number,
  viewportWidth: number,
  tipWidth: number,
  margin = 8,
): number {
  const preferred = -tipWidth / 2
  // shift >= margin - wrapperCenterX  <=>  left edge (wrapperCenterX + shift) >= margin
  const minShift = margin - wrapperCenterX
  // shift <= viewportWidth - margin - tipWidth - wrapperCenterX  <=>  right edge <= viewportWidth - margin
  const maxShift = viewportWidth - margin - tipWidth - wrapperCenterX
  return Math.max(minShift, Math.min(preferred, maxShift))
}
